import { executeMutation } from 'services/graphQL/clientService.js';
import gql from 'graphql-tag';

const mutation = gql`
  mutation RejectGroup($input: RejectGroupInvitationInput!) {
    rejectGroupInvitation(input: $input) {
      success
      errors
      group {
        id
      }
    }
  }
`;

export default function rejectGroup(input) {
  return executeMutation(mutation, { input });
}
